import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/helpers/composables/useI18n';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { MonetizationType } from '@/@types/graphql-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreeTag',
  setup(__props) {

const userStore = useUserStore();

const { tc } = useI18n();

const setBuyBoxTypeToFree = () => {
	if (userStore.buyboxPresentationType !== MonetizationType.Free) {
		userStore.setBuyboxPresentationType({ presentationType: MonetizationType.Free });
	}
};

return { __sfc: true,userStore, tc, setBuyBoxTypeToFree }
}

})